const location = () => {
  const locationInput = document.querySelector('input#input_1_4');

  if(locationInput) {
    locationInput.value = document.querySelector('h1.page-title').textContent;
  }

}

export default location;